import { AiChatPart, TessaAiChatPart, TessaChatMessage } from "@gettactic/api";
import { UIMessage } from "@ai-sdk/react";
import { UIDataTypes, UITools } from "ai";
import { ChatBotTextTool } from "@webV2/pages/Tessa/tools/ChatBotTextTool";
import { ChatBotToolShowWorkplaceRequestInfo } from "@webV2/pages/Tessa/tools/ChatBotToolShowWorkplaceRequestInfo";
import { ChatBotToolShowUsersWorkingLocations } from "@webV2/pages/Tessa/tools/ChatBotToolShowUsersWorkingLocations";
import { ChatBotToolShowReservationInfo } from "@webV2/pages/Tessa/tools/ChatBotToolShowReservationInfo";
import { getToolCallComponent } from './tools/ChatBotSimpleToolCall';

export interface TessaMessageRendererProps<
  T extends AiChatPart = TessaAiChatPart
> {
  part: T;
  isResponse?: boolean;
  message?: TessaChatMessage | TessaResponseMessages;
}

export type TessaResponseMessages = UIMessage<unknown, UIDataTypes, UITools>;

export const messageTypeToComponentMap = {
  text: ChatBotTextTool,
  "tool-show_workplace_request_info": ChatBotToolShowWorkplaceRequestInfo,
  "tool-show_users_working_locations": ChatBotToolShowUsersWorkingLocations,
  "tool-show_reservation_info": ChatBotToolShowReservationInfo,
  "tool-get_current_date_time": getToolCallComponent("Getting current time"),
  "tool-get_date_time": getToolCallComponent("Calculating date and time"),
  "tool-find_users": getToolCallComponent("Finding users"),
  "tool-find_teams": getToolCallComponent("Finding teams"),
  "tool-search_offices_documents": getToolCallComponent("Searching documents"),
  "tool-find_available_resources": getToolCallComponent("Finding available resources"),
  "tool-get_users_working_locations_at_week": getToolCallComponent("Getting users locations"),
  "tool-get_users_in_office_at_week": getToolCallComponent("Getting users in office"),
};
